import React, { FC, PropsWithChildren } from 'react'
import { css } from '@emotion/css'

export const JiraFieldRow: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className={css`
        display: flex;
        position: relative;
        flex-direction: row;
        align-items: flex-start;
        gap: 10px;
        > :nth-child(1) {
          flex: 1 1;
        }
        > :nth-child(2) {
          flex: 2 1;
        }
      `}
    >
      {children}
    </div>
  )
}
